import { css } from "emotion";
import { max } from "../../utils/CssUtils";
import InputWrapper from "./InputWraper";

const SelectFieldStyle = css({
  appearance: "none",
  width: "100%",
  height: 40,
  borderRadius: 4,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "#8D949E",
  backgroundColor: "#f9f9fa",
  fontSize: 16,
  paddingLeft: 12,
  [max(600)]: {
    width: "100%",
    height: 36,
    fontSize: 14,
    paddingLeft: 12
  }
});

const SelectField = ({
  name,
  type,
  placeholder,
  label,
  input,
  options,
  meta: { touched, error }
}) => {
  return (
    <InputWrapper touched={touched} error={error} label={label}>
      <select
        name={input.name}
        {...input}
        data-cy={`${input.name} select`}
        aria-label={`${input.name} select`}
        className={SelectFieldStyle}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </InputWrapper>
  );
};

export default SelectField;
